var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateStamp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16a1.5 1.5 0 001.5-1.5v-11A1.5 1.5 0 0013.5 2H12V.5c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5V2H6V.5c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5V2H2.5A1.5 1.5 0 001 3.5v11A1.5 1.5 0 002.5 16h11zm-.188-1.5H2.687a.188.188 0 01-.187-.188V5h11v9.312a.188.188 0 01-.188.188zm-5.812-3c.275 0 .5-.225.5-.5V8c0-.275-.225-.5-.5-.5h-3c-.275 0-.5.225-.5.5v3c0 .275.225.5.5.5h3z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
export default __webpack_public_path__ + "static/media/2a8695aecee08d603f460d440c60050d-dateStamp.svg";
export { SvgDateStamp as ReactComponent };